// TODO:  REFACTOR THIS HOOK
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { RoomStatusEnum, RoundStagesEnum } from 'shared/constants/shared-enums';
import { generateSalt } from 'shared/constants/utils';
import { useAccount } from 'shared/hooks/use-web3';
import { useHash } from 'shared/hooks/useHash';
import { useGlobalStore } from 'shared/store/globalStore';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';
import { useRoomStore } from 'shared/store/roomStore';

export const useSaltGenerator = () => {
  const { address, chainId } = useAccount();
  const { playerA, playerB, roomStatus, roundCounter, roundStage } = useRoomStore();
  const { activeRoomId } = useParams();
  const { mainSalt, setMainSalt } = usePlayerGamesStore();
  const { handleSetHash, handleGetHash } = useHash();
  const { jwt } = useGlobalStore();
  const processingRef = useRef(false);
  const saltCreator = async () => {
    if (processingRef.current) return;

    processingRef.current = true;
    try {
      let mainSaltValue;
      if (
        !!(
          address &&
          (playerA.address === address.toLowerCase() ||
            playerB.address === address.toLowerCase()) &&
          !mainSalt?.[activeRoomId! + address! + chainId] &&
          roomStatus !== RoomStatusEnum.Closed &&
          jwt[address!] &&
          activeRoomId
        )
      ) {
        mainSaltValue = await handleGetHash({
          hashKey: `${activeRoomId}_${chainId}`,
        });
        if (!mainSaltValue) {
          if (
            roundCounter > 1 ||
            (roundCounter === 1 && roundStage >= RoundStagesEnum.RevealMove)
          ) {
            Sentry.captureException('user lost salt');
            console.log('user lost salt');
            if (roundStage === RoundStagesEnum.RevealMove) {
              return;
            }
          }
          const newSalt = generateSalt();
          let response = await handleSetHash({
            hashValue: newSalt,
            hashKey: `${activeRoomId}_${chainId}`,
          });

          mainSaltValue = await handleGetHash({
            hashKey: `${activeRoomId}_${chainId}`,
          });
          if (!mainSaltValue || !response?.ok) {
            Sentry.captureException('user cant save salt');
            console.log('user cant save salt');
            setMainSalt(activeRoomId! + address! + chainId, newSalt);
          } else {
            setMainSalt(activeRoomId! + address! + chainId, mainSaltValue);
          }
        } else {
          setMainSalt(activeRoomId! + address! + chainId, mainSaltValue);
        }
      }
    } finally {
      processingRef.current = false;
    }
  };
  useEffect(() => {
    if (activeRoomId) {
      saltCreator();
    }
  }, [
    setMainSalt,
    jwt,
    address,
    playerA,
    playerB,
    roomStatus,
    activeRoomId,
    mainSalt,
    handleGetHash,
    handleSetHash,
  ]);
};
